const DEBOUNCE_TIMES = {
  OFF: 0,
  MINIMAL: 200,
  DEFAULT: 2000,
  LONG: 3000,
  EXTRA_LONG: 5000,
}

export default DEBOUNCE_TIMES
